import london from './london';
import manchester from './manchester';
import edinburgh from './edinburgh';
import belfast from './belfast';
import liverpool from './liverpool';
import cardiff from './cardiff';

/**
 * @typedef {Object} CitySection
 * @property {string} heading - The section's h2 heading text.
 * @property {string[]} paragraphs - Array of paragraph strings. Supports a single HTML anchor tag via JSX.
 * @property {string} image - The image source for the section.
 * @property {string} imageAlt - The alt text for the section image.
 */

/**
 * @typedef {Object} CitySeoData
 * @property {string} title - The page <title> tag content.
 * @property {string} description - The meta description.
 * @property {string} keywords - The meta keywords.
 * @property {string} canonicalUrl - The canonical URL for the page.
 * @property {string} ogImage - The Open Graph image URL.
 * @property {string} ogDescription - The Open Graph / Twitter description.
 */

/**
 * @typedef {Object} CityData
 * @property {string} cityName - The display name of the city (e.g., "London").
 * @property {string} searchQuery - The query used for the map search (e.g., "London").
 * @property {string} heroHeading - The main h1 heading in the hero section.
 * @property {string} heroSubheading - The subtitle paragraph in the hero section.
 * @property {string} searchPlaceholder - Placeholder text for the search input.
 * @property {CitySection} networkSection - Content for the "Charging Network" section.
 * @property {CitySection} filterSection - Content for the "Filter by What Matters" section.
 * @property {CitySection} navigateSection - Content for the "Navigate with Confidence" section.
 * @property {CitySeoData} seo - SEO-specific metadata.
 */

/** @type {Object.<string, CityData>} */
const cityLandingPageData = {
    london,
    manchester,
    edinburgh,
    belfast,
    liverpool,
    cardiff,
};

export default cityLandingPageData;
